import React from "react";
import { Block } from "@business-finland/wif-ui-lib";

import styles from "./MigriWidget.module.scss";
import useViewport from "../../../contexts/ViewportContext";

export function MigriWidget(): JSX.Element {

  const iframeStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
    border: "none",
  };
  const { viewport } = useViewport();
  return (
    <Block>
      <Block.Content
        limitedWidth={viewport==="xl"?true:false} >
        <div className={getStyleClassName()}>
          <iframe
            id="migri-iframe"
            src="https://migri.fi-t.seravo.com/en/employee/"
            title="guide on how to apply for a residence permit"
            style={iframeStyle}
          ></iframe>
        </div>
      </Block.Content>
    </Block>
  );
}

export function getStyleClassName(...suffixes: string[]) {
  return styles[["migri-container", ...suffixes].join("__")];
}